export default "__VITE_ASSET__D6tjLt9X__"